import React from "react";
import { useNavigate } from "react-router-dom";
import { Users as UsersIcon, MoreVertical, Eye, Edit2, Ban, Trash2 } from "lucide-react";
import { Dropdown } from "react-bootstrap";
import { StatusBadge } from "../../ui";

/**
 * InstituteRow — Single row in the institutes table.
 * Extract this to keep the list page lean.
 */
const InstituteRow = ({ institute, onStatusChange, onDelete }) => {
  const navigate = useNavigate();
  const inst = institute;

  const statusMap = {
    active: "active",
    trial: "pending",
    inactive: "inactive",
    suspended: "destructive",
  };

  return (
    <tr
      className="sa-mini-table__row--clickable"
      onClick={() => navigate(`/sa/institutes/${inst._id}`)}
    >
      <td>
        <div className="sa-inst-name">
          <div className="sa-inst-avatar">
            {inst.logo ? (
              <img src={inst.logo} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "8px" }} />
            ) : (
              inst.name?.[0] || "?"
            )}
          </div>
          <div>
            <div className="sa-inst-name__text">{inst.name}</div>
            <div className="sa-inst-name__email">{inst.email || "—"}</div>
          </div>
        </div>
      </td>
      <td>
        {inst.subdomain ? (
          <span className="text-muted" style={{ fontSize: '0.75rem' }}>{inst.subdomain}.lmscampus.com</span>
        ) : (
          <span className="text-muted" style={{ fontSize: '0.75rem' }}>—</span>
        )}
      </td>
      <td>{inst.planId?.name || "No Plan"}</td>
      <td>
        <span className="sa-count"><UsersIcon size={12} /> {inst.studentCount ?? 0}</span>
      </td>
      <td>
        <StatusBadge status={statusMap[inst.status] || "active"}>
          {inst.status || "Active"}
        </StatusBadge>
      </td>
      <td>{inst.createdAt ? new Date(inst.createdAt).toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata" }) : "—"}</td>
      <td onClick={(e) => e.stopPropagation()}>
        <Dropdown align="end">
          <Dropdown.Toggle variant="link" className="p-0 border-0 shadow-none text-secondary">
            <MoreVertical size={16} />
          </Dropdown.Toggle>
          <Dropdown.Menu className="shadow-sm border" style={{ fontSize: "0.8125rem" }}>
            <Dropdown.Item onClick={() => navigate(`/sa/institutes/${inst._id}`)}>
              <Eye size={14} className="me-2" /> View Details
            </Dropdown.Item>
            <Dropdown.Item onClick={() => navigate(`/sa/institutes/${inst._id}?edit=true`)}>
              <Edit2 size={14} className="me-2" /> Edit
            </Dropdown.Item>
            <Dropdown.Divider />
            {inst.status !== "suspended" ? (
              <Dropdown.Item
                className="text-warning"
                onClick={() => onStatusChange?.(inst._id, "suspended")}
              >
                <Ban size={14} className="me-2" /> Suspend
              </Dropdown.Item>
            ) : (
              <Dropdown.Item
                className="text-success"
                onClick={() => onStatusChange?.(inst._id, "active")}
              >
                <Eye size={14} className="me-2" /> Reactivate
              </Dropdown.Item>
            )}
            <Dropdown.Item className="text-danger" onClick={() => onDelete?.(inst._id)}>
              <Trash2 size={14} className="me-2" /> Delete
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </td>
    </tr>
  );
};

export default InstituteRow;
